/* eslint-disable */

import "./App.css";
import Header from "./components/layouts/header";
import Footer from "./components/layouts/footer";
import Section from "./components/layouts/section";

function App() {
  return (
    <div className="App">
      <Header />
      <Section />
      <Footer />
    </div>
  );
}

export default App;
